import React from 'react';
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';
import BlockButton from './BlockButton';

function OrderedListButton() {
  return <BlockButton format="orderedList" Icon={<FormatListNumberedIcon fontSize="small" />} />;
}

export default OrderedListButton;
